export default {
      id: "colb-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#colb",
      toString: function () {
        return this.url;
      }
    }